/**
 * Opérateurs entre N conditions (N − 1 entrées), en complétant par `AND` si le
 * tableau stocké est trop court — même règle que l'affichage entre les lignes.
 */
export function effectiveConditionOperators(
  ops: string[] | undefined,
  conditionCount: number,
): string[] {
  if (conditionCount <= 1) return [];
  const list = ops ?? [];
  return Array.from({ length: conditionCount - 1 }, (_, i) =>
    (list[i] ?? "AND").trim(),
  );
}
